module.exports = __webpack_public_path__ + "img/rep-natalie.2e046913.png";